import React, {useEffect, useRef} from 'react';

import popupStyles from "./Popup.module.scss";


const Popup = (props) => {

    const closeButtonRef = useRef(null);

    const currentCloseButtonRef = closeButtonRef?.current;
    useEffect(() => {
        if (closeButtonRef?.current) {
            closeButtonRef.current.focus();
        }
    }, [currentCloseButtonRef]);

    const closeImageKeyDown = event => {
        if(event.key === "Enter" || event.key === " " || event.key === "Escape") {
            props.onClosePopup(event);
        }
    }

    return (props.show
        ? <div className = {popupStyles.popup}>
            {props.children}
            <div
                className = {popupStyles.popupCloseBtn}
                ref = {closeButtonRef}
                role = "button"
                tabIndex = "0"
                aria-label = "Close image"
                onKeyDown = {closeImageKeyDown}
                onClick = {props.onClosePopup}
            />
        </div>
        : null
    );
};

export default Popup;
